module.exports = __webpack_public_path__ + "img/EH.60448384.png";